import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询型号列表
export const queryMatLuminors: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMatLuminors', { ...state.list, loading: true });
    // const res = await $http.post('/model/type/item/luminor/list', payload);
    const res = await $http.post('/v1/asset/item/luminortypes', payload);
    commit('setMatLuminors', { data: res });
  } catch (e) {
    commit('setMatLuminors', { data: [] });
  }
};

// 新增灯具型号（带初始配置）
export const addMatLuminor: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/model/type/item/luminor/add', payload); // 这个是只新增型号，不能同时新增配置，预留
    // await $http.post('/model/type/item/luminor/all/add', payload);
    await $http.post('/v1/asset/item/luminortype/add', payload);
  } finally {
    commit('setDialog', { visible: false, loading: true });
  }
};

// 编辑灯具型号
export const editMatLuminor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/luminor/modify', payload);
    await $http.post('/v1/asset/item/luminortype/modify', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 删除灯具型号
export const deleteMatLuminor: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/luminor/delete', payload);
    await $http.post('/v1/asset/item/luminortype/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 灯具型号排序
export const sortMatLuminor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/luminor/sort', payload);
    await $http.post('/v1/asset/item/luminortype/sort', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 新增灯具型号内的配置
export const addMatLuminorConfig: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/luminor/config/add', payload);
    await $http.post('/v1/asset/item/luminortype/addconfig', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 编辑灯具型号内的配置
export const editMatLuminorConfig: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/luminor/config/modify', payload);
    await $http.post('/v1/asset/item/luminortype/modifyconfig', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 删除灯具型号内的配置
export const deleteMatLuminorConfig: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/luminor/config/delete', payload);
    await $http.post('/v1/asset/item/luminortype/deleteconfig', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 批量新增或编辑配置
export const updateMatLuminorConfig: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/model/type/item/luminor/config/all/modify', payload);
    await $http.post('/v1/asset/item/luminortype/modifyallconfig', payload);
  } finally {
    commit('setLoading', false);
  }
};
